<template>
<div>
  <div v-if="existingReservationComp" class="container">
    <h2 class="small-h2 text-center"><i class="fa fa-list-alt"></i> Booking ID: <strong>{{existingReservationComp.BookingNumber}} </strong></h2>
      <hr>
   
    
    
      <div>
      
        <div class="col-xs-12 col-sm-12 col-md-7 remove-margins">
        <div v-if="existingReservationComp.CustomerStatus" class="alert alert-dismissible" :class="existingReservationComp.StatusClass" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h5 ><strong>Customer Status: </strong>{{existingReservationComp.CustomerStatus}}</h5>
          </div>
          <div v-if="existingReservationComp.SitterStatus" class="alert alert-dismissible" :class="existingReservationComp.StatusClass" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h5 ><strong>Sitter Status: </strong>{{existingReservationComp.SitterStatus}}</h5>
          </div>
          
           <div class="col-sm-12 remove-margins">
           <h4><strong>Submitted date is {{dateFormatter(existingReservationComp.SubmittedDate)}}</strong></h4>
               <div class="col-sm-6 remove-margins">
                    <div class="media-left">
                            <img :src="existingReservationComp.SitterProfilePic" alt="" class="media-object img-responsive img-circle" height="25" width="25"></img>
                    </div>
                        
                    <div class="media-left head-title">
                            <h4 class="media-heading " style="padding-bottom:0px;margin-bottom:0px;"> Sitter Name:  <strong>{{existingReservationComp.SitterName}}</strong></h4>
                    </div>
                </div>
                <div class="col-sm-6 remove-margins">
                    <div class="media-left">
                            <img :src="existingReservationComp.CustomerProfilePic" alt="" class="media-object img-responsive img-circle" height="25" width="25"></img>
                    </div>
                    <div class="media-left head-title">
                            <h4 class="media-heading " style="padding-bottom:0px;margin-bottom:0px;">Customer Name: <strong>{{existingReservationComp.CustomerName}}</strong></h4>
                            
                    </div>
                </div>
          </div>
          <ChatHistory  :transactionId="reservationIdComp"  :submittedDate="existingReservationComp.SubmittedDate" :preventChat="true"></ChatHistory>
          <br>
                     
        <button class="btn btn-block btn-info btn-lg" @click="goBookingsDashboard()">Go to Bookings Dashboard</button>
        </div>
         
        <div class="hidden-xs hidden-sm col-md-4 pull-right reservationSummary">
           <h4 class="text-center"> Summary </h4>
            
            <div v-for="petCard in existingReservationComp.AvailablePetDtos">
              <div>
                <PetSelectCard :showDetails='true' v-bind:petId="petCard.PetId" :key="petCard.PetId"></PetSelectCard>
              </div>
            </div>
            
            <h5 class="small">Total Days: {{existingReservationComp.TotalDays}}</h5>
            <h5 class="small">Dates: {{startDateComp}} - {{endDateComp}}</h5>
            
            <h5 class="small" v-for="service in existingReservationComp.ServicePriceSummaryDtos">{{service.Description}}</h5>
            <h4 class="text-success">Total Price: {{totalPriceComputed}} {{currencyComp}}</h4>
            
            
        </div>
     </div>
     
      
        
        

      


    
        
        
    

    
  </div>  <!-- closing the main container-->


  <div v-else class="container">
    <div class="text-center">
      <h1><i class="fa fa-spinner fa-spin"></i> Loading..</h1>
    </div>
  </div>  <!-- closing the v-else container-->

</div>
</template>
<script>


import ChatHistory from './ChatHistory.vue'
import auth from '../../../auth'
import store from '../../../data/store'
import PetSelectCard from '../../SharedComponents/PetSelectCard'
import router from '../../../router'

export default {
    data () {
        return {
            existingReservation: null,
            notification:'',
            reviewDesc: '',
            error: false,
          
            summaryCollapse: false,
            sending: false,
            ready: true,
            customerRating: '',
            rated: false,
            sent: false,
          
            loading: false,
            reviewDto: {
                Description: '',
                Rating: ''
            },
          
        }
    },
    components: {
        PetSelectCard,
        ChatHistory,
        
    },
    updated: function() {
        var self = this
      $('[data-toggle="popover"]').popover();


    // $zopim(function (){
    //     $zopim.livechat.sendVisitorPath();
    // });

    },
    computed: {
      
        currencyComp: function(){
        return store.getters.CountryData.Currency
        },
        timezoneComp: function(){
            return store.getters.CountryData.CountryTimeZone
        },
        
        notStartedComp: function(){
            var self=this
            var now = moment()
            var startDate = moment(self.existingReservationComp.StartDate)
            if (startDate.isAfter(now))
                return true
            else
                return false
        },
        rejectedComp: function(){
            var self = this
            if (self.existingReservationComp.IsSitterRejected == true || self.existingReservationComp.IsCustomerCancelled == true)
                return true
            else    
                return false
        },
        totalPriceComputed: function(){
            var totalPrice = this.existingReservation.TotalPrice
            return  totalPrice
        },
        startDateComp: function(){
            var self = this
            return moment(self.existingReservation.StartDate).format('DD MMM YYYY')
        },
        endDateComp: function(){
            var self = this
            return moment(self.existingReservation.OriginalEndDate).format('DD MMM YYYY')
        },
        existingReservationComp: function(){
            return this.existingReservation
        },
        reservationIdComp: function(){
            var self=this;
            if (self.$route.params!=null)
            return self.$route.params.reservationId
        },
    },
    methods: {
        dateFormatter: function(date){
            return moment(date).format('HH:MM A - DD MMM YYYY')
        },
       
        goBookingsDashboard: function(){
            this.$router.push({path: '/bookings-dashboard'})
        },
        goSupport(){
             router.push({
                path: '/contact-support/' + '?bookingId=' + this.existingReservationComp.BookingNumber,
                force: true
                })
        },
        initReservation(){
            var self = this
            self.loading = true
            $.ajax("https://www.dupaws.com/services/api/admin/getReservation/" + self.$route.params.reservationId, {
                    type: 'GET',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        self.existingReservation = data
                        self.ready = true
                        self.loading = false
                    },
                    error: function(data, status, error) {
                        self.loading = false
                        self.error = data.responseJSON.Message
                    
                  }
                    
            }); 

        },
        
        
         
    },
    mounted: function () {
       var self = this;
       self.$forceUpdate();
       self.initReservation()

    }
  

}
 
</script>
<style scoped>
.modal {
  text-align: center;
}

 .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

.reservationSummary{
    border: 1px;
    
    border-style: solid;
    border-color:#c3c3c3;
    border-radius: 5px;
    background: whitesmoke;
}

.border-style{
    border: 1px #a6adad;
    border-style: solid;
    border-radius: 5px;
    margin:5px;
    padding:5px;
}

.summary-desc{
    margin:10px;
}

.some-style{
    background-color: white;
    padding: 1px;
    border-radius: 2px;
    border: 5px #09589e;
    box-shadow: 0 0 0 2px #e0e0e0;
    
    margin-bottom:3%;
}

.text-success {
    color: #62c364;
}

.flex-item{
    margin:3px;
}

.btn-default:hover {
    color: #333;
    background-color: #ffffff;
    border-color: #a7a7a7;
}

.btn-default:focus, .btn-default.focus {
    color: #333;
    background-color: white;
    border-color: #8c8c8c;
}


.text-price{
   font-family: 'Yanone Kaffeesatz', sans-serif;
  font-weight: 600;
  font-size: 1.95em;
  color: #737574;
  padding-bottom: 0;
}

.list-flex{
    max-width:500px;
    display:flex;
    
    
}


.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #ffffff;
    opacity: 1;
}


</style>


// WEBPACK FOOTER //
// viewReservationAdmin.vue?f5696ada